import React from 'react'
import SellerTransections from '../components/SellerTransections'

const SellerTransectionList = () => {
  return (
    <div>
        <SellerTransections />
    </div>
  )
}

export default SellerTransectionList